<template>
  <div>

      <Header
      :BackPage='false'
      :HideCart='false'
      Title='add novo carro'
      />

    <Loader
    :isLoading='Loading'
    />


    <div class='container'>

      <TitleH3
      class='titleh1 container mt-5'
      Text='Escolha um carro'
      />

    <v-select class='vselect' label="name" :options="carBrand" :value='carro.brand' @input="setBrand" placeholder="Escolha uma marca"></v-select>
    <v-select class='vselect' label="name" :options="newModel" :value='carro.model' @input="setModel" placeholder="Escolha um modelo"></v-select>
    <v-select class='vselect' label="year" :options="carYear" :value='carro.year' @input="setYear" placeholder="Insira o ano"></v-select>

      <TitleH1
      v-show='this.carro.model && this.carro.year'
      class='titleh1 mt-3 '
      Text='Escolha uma versão'
      />


        <div class="col-12  m-auto " v-show='noCars'>
            <article class="card card-body bg-transparent">
                <figure class="text-center">
              
                    <figcaption class="pt-4">
                    <h5 class="title">Não há carros disponivel para esse modelo e ano.</h5>
                    <p class=''>Escolha outra carro </p>
                    </figcaption>

                         <img
                            class=' m-auto'
                            :src='NotProductImg'
                           
                            />
    
                </figure> <!-- iconbox // -->
            </article> <!-- panel-lg.// -->
        </div><!-- col // -->

   <div class="list-group"       v-show='this.carro.model && this.carro.year'>

      <SelectCar
      v-for='c in car'
      :key="c.id"
      :CarId="c.id"
      :CarObj='c'
      :CarImg='c.img'
      :CarModel='c.model.name'
      :CarMotor='c.motor.liters'
      :CarMotorDescription='c.motor.description'
      :SelectFunction='setVersion'
      />

    </div>
    </div>

<div class='Spacer'></div>
<Footer>

        <Button
        v-show='carro.choice'
        id='next_button'
        Type='submit'
        Text='CADASTRAR CARRO'
        :ButtonFunction='addCarGarage'
        />
</Footer>



  </div> 
</template>

<script>
import Header from '../../components/Header/Header'
import Logo from '../../assets/img/appName.svg'
import TitleH3 from '../../components/Title/TitleH3'
import TitleH1 from '../../components/Title/TitleH1'
import Button from '../../components/Button/ButtonCallToAction'
import SelectCar from '../../components/Cards/CenteredCarSelect'
import Footer from '../../components/Container/FooterContainer'
import {Models} from '../../tools/carModels'
import {Year} from '../../tools/carYear'
import {Brand} from '../../tools/carBrand'
import Loader from '../../components/Load/LoadOverlay'
import {mapActions, mapState} from 'vuex'
import NotProductImg from '../../assets/img/no-product.svg'

export default {
  components: {
    Header,
    TitleH1,
    TitleH3,
    Button,
    SelectCar,
    Footer,
    Loader,
  },
  data() {
    return {
      NotProductImg:NotProductImg,
      noCars:false,
      Loading: false,
      Logo: Logo,
      model: Models,
      carro: {
        brand:'',
        model: '',
        year: '',
        version: '',
        selected:{},
        choice: false,
      },
      modelos:[],
      searchCar: {
        year:'',
        initial:'initial'
      },
      car: {

        },
      yearArray: Year

    }
  },
  methods: {
    ...mapActions('home',['ActionLoadGarage']),
    ...mapActions('add_car',['ActionGetCarModel','ActionGetCarVersion','ActionAddCarGarage']),
    ...mapState('add_car',['car_version']),
    next_step() {
      console.log('next step')
    },
    search(input) {
      if (input.length < 1) { return [] }
      return this.yearArray.filter((year) =>  this.startCom(year.fields.year,input)  )
    },
    searchModel() {

      return Models.map(model => model.name + model.brand.name)
    },
    startCom (value,input){
      return String(value).toLowerCase().startsWith(input);
    },
    getResultValue(result) {
      return result.fields.year
    },
    getResultModelValue(result) {
      return result.name
    },
    setYear(e) {
        if (e === null){
          this.carro.year = ''
          this.carro.choice = false
        }
        else {
        this.carro.year = e
        this.handleYearSubmit()
        }
        
    },
    setVersion(e) {
        this.carro.selected = e
        this.carro.choice = true
    },
    setModel(e) {
      if (e === null) {
        this.carro.model = ''
        this.carro.choice = false
      }
      else {
        this.carro.model = e
      }
    
        
    },
    setBrand(e) {
        if (e === null) {
            this.carro.brand = e
        }
        else {
        this.carro.brand = e
        }



    },

    async addCarGarage(){
        this.Loading = !this.Loading
        const garage = {
            'client':this.userLocalId,
            'plate' :'-',
            'car': this.carro.selected,
            'ano': this.carro.year.year
        }
        const addCar = await this.ActionAddCarGarage(garage)
        if (addCar == 201) {
            this.ActionLoadGarage({id:this.userLocalId})
            this.Loading = !this.Loading
            this.$router.push({name:'home'})
        }
        else {
            alert('Erro ao cadastrar carro.')
            this.$router.go(-1)
        }

    },    
    async handleYearSubmit() {
      this.Loading = !this.Loading
      const version = await this.ActionGetCarVersion({model__name:this.carro.model.name, year__year:this.carro.year.year})
      if (version == 0){
          this.noCars = !this.noCars
          this.carro.year = null
          this.carro.model = null
          this.carro.brand = null
          this.Loading = !this.Loading
      }
      else {
        this.noCars = false
        this.car = version
        this.Loading = !this.Loading
      }
      
    },
    handleModelSubmit(result) {
      this.carro.model = result
    },
    mapModels(brand){
    return this.carModel.filter(function(obj) { return obj.brand === brand.name ; });
    },
  },
  computed: {
    carModel() {
      return Models.map(model => ({
            'id': model.id,
            'name': model.name + ' - ' + model.brand.name,
            'brand':model.brand.name,
            'label':model.name + ' - ' + model.brand.name
      }))
    },
    newModel() {
      if (this.carro.brand === null) {
        return this.carModel
      }
      else {
        return Models.filter(obj => obj.brand.name == this.carro.brand.name);
      }
    },
    carYear() {
      return Year.map(year => ({
          'id': year.pk,
          'year': year.fields.year
      }))
    },
    carBrand() {
      return Brand.map(brand => ({
          'id': brand.id,
          'name': brand.name
      }))
    },
    userLocalId (){
      return localStorage.getItem('id_user');
    },
  },
      mounted() {
   
  }

}
</script>

<style scoped lang="css">
.vselect{
    margin-top:10px;
}


.Spacer{
  height: 8.625rem;
}
.titleh1{
  display: flex;
align-items: center;
text-align: center;
}

.inputName{
  margin-top:5.25rem;
}

#next_button{
  margin-top:2.5rem;
}
  .register{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:6.25rem;  
}


  @media (min-width: 1400px) and (max-width: 2600px) {
  .register{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }
</style>
